export const convertAddressStringToObject = (addressString) => {
  if (!addressString) return {}

  const addressParts = addressString?.split('|')
  const [house, area, postalTown, county, postcode] = addressParts || []
  return {
    house: house || '',
    area: area || '',
    postalTown: postalTown || '',
    county: county || '',
    postcode: postcode || ''
  }
}
